// extracted by mini-css-extract-plugin
export default {"comment":"CommentAnswer-module__comment--e4640","button":"CommentAnswer-module__button--cdc3d","commentForm":"CommentAnswer-module__commentForm--cdbf7"};